import React from 'react';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';

export default ({ text, iconPath }) => {
  return (
    <li className="my4">
      <Icon className="mr3" path={iconPath} />
      {text}
    </li>
  );
};
